var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 138,
    viewBox: "0 0 157 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.909 75.4218C141.909 109.466 114.311 137.064 80.2669 137.064C46.2231 137.064 18.625 109.466 18.625 75.4218C18.625 41.378 46.2231 13.7793 80.2669 13.7793C114.311 13.7793 141.909 41.378 141.909 75.4218Z",
    stroke: "#C4C3C3",
    strokeWidth: 0.828738,
    strokeDasharray: "4.16 4.16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.036 75.4215C126.036 100.703 105.541 121.198 80.2598 121.198C54.978 121.198 34.4844 100.703 34.4844 75.4215C34.4844 50.1403 54.978 29.6455 80.2598 29.6455C105.541 29.6455 126.036 50.1403 126.036 75.4215Z",
    stroke: "#C4C3C3",
    strokeWidth: 0.828738,
    strokeDasharray: "4.18 4.18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9726 83.7216L5.82812 83.6865",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14892 81.5503L5.32812 82.317",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00941 80.5596L3.99219 81.6785",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80469 81.3281L2.60172 82.1442",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.828125 83.4058L1.97201 83.4408",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65625 85.5763L2.47764 84.8096",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78906 86.5667L3.80629 85.4478",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00016 85.7985L5.20312 84.9824",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.23 67.7681L155.727 68.3127",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M153.859 68.2417L154.239 68.5915",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.477 70.6555L153.98 70.1108",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.84 70.1818L155.461 69.832",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.154 3.75825L108.938 3.72559",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.003 0.820801L106.984 1.86075",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.609 3.46631L104.826 3.49838",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M106.766 6.40469L106.784 5.36475",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0325 116.044C19.1571 116.306 17.699 117.593 17.2001 119.118C17.1164 117.701 16.2166 115.92 15.2266 115.663C16.4346 115.236 17.743 113.666 18.091 112.344C18.0281 113.73 19.2866 115.743 20.0325 116.044Z",
    fill: "#D8D8D8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5391 9.32933C39.8638 9.44871 38.667 10.2802 38.1634 11.373C38.2234 10.3105 37.7073 8.90587 36.9922 8.6291C37.9288 8.41529 39.0394 7.35931 39.413 6.4043C39.2461 7.43177 40.0093 9.04009 40.5391 9.32933Z",
    fill: "#D8D8D8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.035 17.0444C129.133 17.0248 128.418 16.2783 128.438 15.3767C128.458 14.4752 129.204 13.7601 130.105 13.7797C131.007 13.7993 131.722 14.5458 131.703 15.4474C131.682 16.349 130.937 17.064 130.035 17.0444Z",
    fill: "#D1D9E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.047 124.041C129.262 124.024 128.64 123.374 128.657 122.589C128.673 121.804 129.324 121.181 130.109 121.198C130.894 121.215 131.516 121.865 131.499 122.65C131.482 123.435 130.832 124.058 130.047 124.041Z",
    fill: "#D8D8D8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0014 38.715C11.5156 38.7044 11.1302 38.3023 11.1408 37.8159C11.1509 37.33 11.5536 36.9452 12.0394 36.9553C12.5253 36.966 12.9107 37.368 12.9006 37.8539C12.8899 38.3403 12.4872 38.7257 12.0014 38.715Z",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9569 77.6449L83.9569 68.6449C83.5969 68.2849 83.0969 68.0649 82.5469 68.0649H75.5469C74.4469 68.0649 73.5469 68.9649 73.5469 70.0649V77.0649C73.5469 77.6149 73.7669 78.1149 74.1369 78.4849L83.1369 87.4849C83.4969 87.8449 83.9969 88.0649 84.5469 88.0649C85.0969 88.0649 85.5969 87.8449 85.9569 87.4749L92.9569 80.4749C93.3269 80.1149 93.5469 79.6149 93.5469 79.0649C93.5469 78.5149 93.3169 78.0049 92.9569 77.6449ZM77.0469 73.0649C76.2169 73.0649 75.5469 72.3949 75.5469 71.5649C75.5469 70.7349 76.2169 70.0649 77.0469 70.0649C77.8769 70.0649 78.5469 70.7349 78.5469 71.5649C78.5469 72.3949 77.8769 73.0649 77.0469 73.0649Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOffer);
export default __webpack_public_path__ + "static/media/delete_offer.beac926c5ea9c8872da1cd1054a545dd.svg";
export { ForwardRef as ReactComponent };